import React from "react"
import { navigate } from "gatsby"
import { useTheme } from '~/contexts/ThemeContext'

import { IconChevLeft } from '~/components/icons/chevrons'

import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/pdp/pdp.module.scss"

const BreadCrumb = ({ vintage=false }) => {
  const { bread, setBread } = useTheme()

  let sess = (typeof sessionStorage !== 'undefined') && sessionStorage.getItem('fbread')
  if (sess && !sess.includes(bread.handle)) {
    sess = false
    sessionStorage.removeItem('fbread')
  }
  let url = sess ? sess : bread.handle === 'search' ? '/search' : `/collections/${bread.handle}`
  if (vintage) {
    url = sess ? sess : bread.handle === 'search' ? '/search' : `/vintage/${bread.handle}`
  }

  const handleClick = (e) => {
    setBread(curr => {curr.click = true; return curr})
    navigate(url)
  }

  return (
    <>
      {bread ? (
        <div className={styles.pdp_head}>
          <button className={[aria_btn,styles.bread].join(' ')} onClick={handleClick}>
            <IconChevLeft />

            <span>
              {bread.title}
            </span>
          </button>
        </div>
      ) : (
        <div className={styles.nobread} />
      )}
    </>
  )
}

export default BreadCrumb

